import { useCallback } from 'react';
import type { ExtraErrorAttributes } from '@jira/platform__error-boundary/src/ErrorBoundary.tsx';
import { fireTrackAnalytics, useAnalyticsEvents } from '@atlassian/jira-product-analytics-bridge';

// The Relay `@required` failure in `Nav4ProjectsContent` reports far more terminal errors than
// matching UFO experience failures, creating an attribution blindspot. Fire a dedicated track
// event when the boundary catches it so the affected sessions can be traced in Amplitude via
// session replays. See go/terminal-errors-investigation for context.
const isMissingRequiredValueError = (error: Error): boolean =>
	error.message.includes("Missing @required value at path 'jira_projectsSidebarMenu'");

type OnError = (location: string, error: Error, attributes: ExtraErrorAttributes) => void;

// TODO: remove entire file when the feature gate is cleaned up
export const useRequiredErrorAnalytics = (): OnError => {
	const { createAnalyticsEvent } = useAnalyticsEvents();

	return useCallback(
		(location: string, error: Error, attributes: ExtraErrorAttributes) => {
			if (!isMissingRequiredValueError(error)) {
				return;
			}
			fireTrackAnalytics(
				createAnalyticsEvent({}),
				'sidebarProjects missingRequiredValueErrorCaught',
				{
					location,
					errorName: error.name,
					errorMessage: error.message,
					errorHash: attributes.hash ?? null,
				},
			);
		},
		[createAnalyticsEvent],
	);
};
